import React, { type FC } from 'react';

export const Organization: FC = () => {
    const organizationImage = new URL('./organization.png', import.meta.url).toString();
    return (
        <div className="text-white flex flex-col gap-4 pb-2">
            <p className="text-2xl">Organization</p>
            <p>
                You can invite team members to your organization on Intaglio as Designers, Publishers, or
                Administrators.
            </p>
            <p>
                <span className="font-bold">Designers:</span> Can create and edit design templates. They can also
                publish creative assets using templates.
                <br />
                <span className="font-bold">Publishers:</span> Can publish creative assets using templates. Publishers
                cannot create or edit template designs.
                <br />
                <span className="font-bold">Administrators:</span> Can do everything designers can do, and also add or
                remove members from the organization.
            </p>
            <img src={organizationImage} alt="organization" />
        </div>
    );
};
